import * as React from "react";
import { RouteComponentProps } from "react-router-dom";
import { FetchWithAuth } from "digimaker-ui/util";
import { Form, Button, Breadcrumb, Select, Space, message } from "antd";
import "antd/dist/antd.css";
import { SendOutlined, SaveOutlined, CloseOutlined } from "@ant-design/icons";
import AntdFormItemFactory from "../lib/AntdFormItemFactory";
import DataSource, { DATE_SUBMIT_FORMAT } from "../lib/DataSource";
import { Link } from "react-router-dom";
import { util } from "../lib/Util";

const { Option } = Select;

export default class StudentCreate extends React.Component<
  RouteComponentProps,
  {
    definition: any;
    typeArr: string[];
    fields: any;
    validation: any;
    courseList: any;
    agencyList: any;
  }
> {
  contentType = "student";

  constructor(props) {
    super(props);
    this.state = {
      definition: null,
      typeArr: [this.contentType],
      fields: [],
      validation: "",
      courseList: [],
      agencyList: [],
    };
  }

  componentWillMount() {
    let studentDef = DataSource.loadFields(this.contentType).then((state) =>
      this.setState({
        definition: state.definition,
        fields: state.fields,
      }),
    );

    let courseDef = DataSource.loadList("course", {
      sortby: "c.name asc",
    }).then((courseList) =>
      this.setState({
        courseList: courseList.list,
      }),
    );

    let agencyDef = DataSource.loadList("agency", {
      sortby: "c.name asc",
    }).then((agencyList) =>
      this.setState({
        agencyList: [{ id: 0, name: "None" }, ...agencyList.list],
      }),
    );

    Promise.all([studentDef, courseDef, agencyDef]);
  }

  handleSubmit(values) {
    if (values.birthdate) {
      values.birthdate = values.birthdate.format(DATE_SUBMIT_FORMAT);
    }

    if (values.starting_date) {
      values.starting_date = values.starting_date.format(DATE_SUBMIT_FORMAT);
    }

    FetchWithAuth("content/new/467/" + this.contentType, {
      method: "POST",
      body: JSON.stringify(values),
    }).then((data) => {
      this.setState({ validation: data });
      console.log(data);

      if (!data.error) {
        //goto student list page
        this.props.history.push("/student/list");
      } else {
        util.handleError(data.error);
      }
    });
  }

  render() {
    if (!this.state.definition || this.state.courseList.length === 0) {
      return <div className="loading"></div>;
    }

    let def = this.state.definition;
    let fields = this.state.fields;
    let fieldFactory = new AntdFormItemFactory();
    // let props = this.props;
    // console.log(props.match);
    let intakes = util.intakes();
    let courseList = this.state.courseList;
    let agencyList = this.state.agencyList;

    return (
      <div id={"create-" + this.contentType}>
        <h2>Create {def.name}</h2>
        <Breadcrumb>
          <Breadcrumb.Item>
            <Link to="/">Home</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/student/list">Student</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>Create</Breadcrumb.Item>
        </Breadcrumb>
        <Form
          className="icd-form"
          name={this.contentType + "-create"}
          onFinish={(values) => this.handleSubmit(values)}
          initialValues={{}}
        >
          {fieldFactory.getFormItem(fields.firstname)}
          {fieldFactory.getFormItem(fields.lastname)}
          {fieldFactory.getFormItem(fields.student_no)}
          {fieldFactory.getFormItem(fields.sex)}
          {fieldFactory.getFormItem(fields.birthdate)}
          {fieldFactory.getFormItem(fields.nationality)}
          {fieldFactory.getFormItem(fields.telephone)}
          {fieldFactory.getFormItem(fields.email)}
          {fieldFactory.getFormItem(fields.address1)}
          {fieldFactory.getFormItem(fields.address2)}
          {fieldFactory.getFormItem(fields.address3)}
          {fieldFactory.getFormItem(fields.address4)}
          {fieldFactory.getFormItem(fields.intake)}
          {fieldFactory.getFormItem(
            fields.course,
            null,
            "select",
            courseList.map((course) => {
              return { value: course.id, name: course.name };
            }),
          )}
          {fieldFactory.getFormItem(fields.stage)}

          {fieldFactory.getFormItem(
            fields.status,
            null,
            "select",
            util.statusList.map((status) => {
              return { value: status, name: status };
            }),
          )}

          {fieldFactory.getFormItem(
            fields.agency,
            null,
            "select",
            agencyList.map((agency) => {
              return { value: agency.id, name: agency.name };
            }),
          )}

          {fieldFactory.getFormItem(fields.note)}

          {fieldFactory.getFormItem(fields.entry_year)}

          <Space>
            <Button type="primary" icon={<SendOutlined />} htmlType="submit">
              Submit
            </Button>
            <Link to="/student/list">Cancel</Link>
          </Space>
        </Form>
      </div>
    );
  }
}
